import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { getImageAssetPath } from '@/lib/imageHelper';
import { BusinessHero } from '@/components/ui/content-blocks';
import { Check } from 'lucide-react';

const HeroSection = () => {
  const { t } = useTranslation();
  const heroImage = getImageAssetPath('hero-salescockpit.webp');

  return (
    <BusinessHero
      title={t('salescockpitPage.header.mainTitle')}
      titleHighlight={t('salescockpitPage.header.titleHighlight')}
      subtitle={t('salescockpitPage.header.subtitle')}
      description={t('salescockpitPage.header.details')}
      primaryCTA={{
        label: t('salescockpitPage.header.primaryCTA'),
        href: "#contact"
      }}
      secondaryCTA={{
        label: t('salescockpitPage.header.secondaryCTA'),
        href: "#services"
      }}
      image={{
        src: heroImage,
        alt: t('salescockpitPage.header.title'),
        width: 600,
        height: 400
      }}
      badges={[
        {
          icon: <Check className="h-5 w-5 mr-1" />,
          text: "Offline-fähig",
          position: "top-right",
          color: "blue"
        },
        {
          icon: <Check className="h-5 w-5 mr-1" />,
          text: "ERP-Integration",
          position: "bottom-left",
          color: "green"
        }
      ]}
      imageInfo={{
        text: "KI generiert",
      }}
      backgroundStyle="blue"
    />
  );
};

export default HeroSection; 